module.exports = __webpack_public_path__ + "img/registration-icon.7c12388.svg";